import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import Cookies from 'universal-cookie';
import axios from 'axios';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { Trans } from "react-i18next";   
import "../../config/i18n";
import { withTranslation } from "react-i18next";

const config = {
  apiKey: 'AIzaSyA5h0ra_DpRn2ii7bN0kQb0yFfmZgQg-XE',
  authDomain: 'neat-talent-402217.firebaseapp.com',
};

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

const uiConfig = {
  signInFlow: 'popup',
  signInOptions: [
    firebase.auth.PhoneAuthProvider.PROVIDER_ID,
  ],
  callbacks: {
    signInSuccessWithAuthResult: function(authResult, redirectUrl) {
      var phone_no = authResult['user']['phoneNumber'];
      const cookies = new Cookies();
      var hosturl = window.location.href;
      var api_url = localStorage.getItem('api_url');
      var signin = new FormData();
      signin.set('phone', phone_no);
      signin.set('fcmtoken', cookies.get('mytoken'));
      axios({
        method: 'post',
        url: api_url+'webcheckphone',
        data: signin,
        config: { headers: {'Content-Type': 'multipart/form-data' }}
      }).then(res => {
        if(res.data.status !== "false"){
          cookies.set('signuptab', 'yes');
          cookies.set('signupmobileno', phone_no);
          hosturl = hosturl.replace('Signupfirebase','');
          window.location.href = hosturl;
          // window.location.href = "/";
        } else {
          alert('Sorry, The mobile number is already registered.');
          cookies.set('signuptab', 'yes');
          cookies.set('signupmobileno', "");
          hosturl = hosturl.replace('Signupfirebase','');
          window.location.href = hosturl;
          // window.location.href = "/";
        }
      })
    } 
  }
};

class Signupfirebase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      api_url:localStorage.getItem('api_url'),
    };
  }

  componentDidMount(){
    if (this.props.i18n.language === 'ar' || this.props.i18n.language === 'he') {
      document.body.dir = 'rtl';
      document.body.classList.add('rtl');
      document.body.classList.remove('ltr')
    } else {
      document.body.dir = 'ltr';
      document.body.classList.remove('rtl');
      document.body.classList.add('ltr');
    }
    
    const cookies = new Cookies();
    if(cookies.get('onboarded') === 'true'){
      this.props.history.push("/app")
    } else {

    }
  }

  render() {
    const { t } = this.props;
    return (
      <div className="welcomePage">
        <div className="welcomePageCenterContent">
          <div className="welcomeLogo"></div>
          <div className="w-100">
            <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()}/>
          </div>
          <div class="white-color esmh-14 text-center amt10">
            <b>
              <Trans i18nKey="By using our services you are agreeing to ">
                By using our services you are agreeing to 
              </Trans>
              <span>
                <a href="https://kabadate.com/helppage/Terms-and-Conditions" className="white-color">
                  <Trans i18nKey="Terms and Conditions">
                    Terms and Conditions
                  </Trans>
                </a>
              </span>
            </b>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation("translations")(Signupfirebase);